export default __webpack_public_path__ + "static/media/giide-share-.08530610.jpg";